export default __webpack_public_path__ + "static/media/case-study-tips.77fb74d3.png";